import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../AssetHelpers'
type Props = {
  className?: string
  path: string
  svgClassName?: string
}

/**
 * Getting error when updating dependencies, intermittently. 3-year-old suggestions would require downgrading dependencies.
 * TS2786: 'SVG' cannot be used as a JSX component.
 *   Its type 'typeof InlineSVG' is not a valid JSX element type.
 *     Type 'typeof InlineSVG' is not assignable to type '(props: any, deprecatedLegacyContext?: any) => ReactNode'.
 *       Type 'string | number | bigint | boolean | Iterable<ReactNode> | ReactElement<unknown, string | JSXElementConstructor<any>> | Promise<...> | null' is not assignable to type 'ReactNode'.
 *         Type 'bigint' is not assignable to type 'ReactNode'.
 *
 * @see https://github.com/gilbarbara/react-inlinesvg/issues/217#issuecomment-2404609315
 */
const SVGComponent = SVG as React.FC<any>;

const KTSVG: React.FC<Props> = ({className = '', path, svgClassName = 'mh-50px'}) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVGComponent src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  )
}

export {KTSVG}
